<template>
  <LayoutPublic v-if="ready && this.$route.meta.public">
    <router-view />
  </LayoutPublic>
  <LayoutApp v-else-if="ready && this.$route.meta.requiresAuth">
    <router-view />
  </LayoutApp>
  <div v-else></div>
</template>

<script>
import LayoutPublic from "./views/LayoutPublic.vue";
import LayoutApp from "./views/LayoutApp.vue";

export default {
  name: "App",
  components: {
    LayoutPublic,
    LayoutApp
  },
  data: () => {
    return {
      ready: false
    };
  },
  created() {
    this.$router.onReady(() => {
      this.ready = true;
    });

    //tinyMCE popups problem
    document.addEventListener("focusin", (e) => {
      const classList = e.target?.classList || [];
      if (
        classList.contains("tox-tbtn") ||
        classList.contains("tox-textfield") ||
        classList.contains("tox-textarea") ||
        classList.contains("tox-tinymce-aux") ||
        classList.contains("moxman-window") ||
        classList.contains("tam-assetmanager-root")
      ) {
        e.stopImmediatePropagation();
      }
    });
  }
};
</script>
